import { Box, Grid, Divider, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import InlineText from '../../../Common/InlineText';
import { concatStrings, getBranchById, getUserById } from '../../../../utilities/common';
import { getNameFromList } from '..';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}))

const GRID_SPACE = 2;

function BasicInformationSummary(props) {
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  const { data, branchList, userList, 
    statusList, orderInfoLoading, isCurrentStep } = props;
  const { incidentLevelList, incidentTypeList, 
    actionRequiredList, sourceList, incidentStatusList } = statusList;

  return (
    <Box>
      <Grid container spacing={GRID_SPACE} className={classes.section}>
        <Grid item xs={6}>
          <InlineText 
            title={t('incident_level')}
            text={getNameFromList(incidentLevelList, data.level)}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('investigation_status')}
            text={getNameFromList(incidentStatusList, data.status)}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('record_time')}
            text={moment.unix(data.record_time).format("YYYY-MM-DD")}
          />
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={GRID_SPACE} className={classes.section}>
        <Grid item xs={12}>
          <InlineText 
            title={t('common:tracking_number')}
            text={data.tracking_no}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('location')}
            loading={orderInfoLoading}
            text={getBranchById(data.location, branchList)?.name || "Unknown"}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('last_tracking_path')}
            loading={orderInfoLoading}
            text={data.parcel_last_state || "-"}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('occurrence_time')}
            text={moment.unix(data.occurrence_time).format("YYYY-MM-DD")}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('driver_id')}
            loading={orderInfoLoading}
            text={data.driver_id || "-"}
          />
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={GRID_SPACE} className={classes.section}>
        <Grid item xs={6}>
          <InlineText 
            title={t('recorded_by')}
            text={getUserById(data.recorded_by, userList)?.username || data.recorded_by}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('start_from')}
            text={concatStrings(" - ", getNameFromList(sourceList, data.source), data.other_source)}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('incident_type')}
            text={concatStrings(" - ", getNameFromList(incidentTypeList, data.incident_type), data.detail)}
          />
        </Grid>
        {isCurrentStep ?
          <Grid item xs={12}>
            <InlineText 
              title={t('notes')}
              text={data.notes}
            />
          </Grid>: null
        }
      </Grid>
    </Box>
  )
}

export default BasicInformationSummary